export const CHANGE_ICON = "CHANGE_ICON";
